module.exports = __webpack_public_path__ + "static/media/map-animation-play-hover.fce16890.svg";